import AboutPageSection from "./AboutPage";
import SideMenu from "../../components/SideMenu";
import About from "../../components/AboutPage/About";
const AboutPage = () => {
  return (
    <AboutPageSection>
      <SideMenu />
      <About />
    </AboutPageSection>
  );
};
export default AboutPage;
